/**
 * @file コンポーネント：症例サムネイル画像 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み

// スタイル読み込み
import { StyledMediaImage } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledMediaImage
            alt={props.title}
            id={"ad-" + props.promotionId}
            src={props.thumbnail}
        />
    );
};
